import React, {
  Fragment,
  useEffect,
  // , useState
} from "react";
import Navbar from "../CommonNavbar/CommonNavbar";
import ResponsiveSidebar from "../ResponsiveSidebar/ResponsiveSidebar";
import MaintenanceBanner from "../MaintenanceBanner";
import {
  LoyoutWrapperContent,
  LayoutResponsiveSidebar,
  LayoutContentWrapper,
  //   StyledToastContainer,
} from "./StyledCommonLayout";
import { connect } from "react-redux";
import { clearLocalComponentData } from "../../../redux/fui/index";
import {
  fetchServersInstances,
  isCheckboxServiceEndDateSelectedAction,
} from "../../../redux/ServersReducer/ServersActions";

import { fetchInstanceData } from "../../../redux/fui/index";

// import { useCommonSidebarStyles } from "../makeStylesMaterialUi/CommonMakeStyles";

import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";
import { tokenValidation } from "../../../helper/customizedHooks";
import { Footer } from "../Footer";

const CommonLayout = (props) => {
  const {
    email,
    idToken,
    children,
    screenName,
    history,
    fetchServersInstances,
    fetchInstanceData,
  } = props;

  /**
   * Common Layout of the Page
   * @author Carlos Montes
   * @version 1.0
   * @see Used in component: routes.js
   */

  //   const serviceEndDateClasses = useCommonSidebarStyles();

  useEffect(() => {
    setInterval(() => {
      tokenValidation();
    }, 4000);
  }, []);

  useEffect(() => {
    const eId = email === undefined ? undefined : email.split("@")[0];
    if (eId && idToken) {
      fetchServersInstances(eId, idToken);
      fetchInstanceData(email, idToken);
    }
  }, [email, screenName, idToken]);

  // Check if access is restricted (set by HOC)
  const isAccessRestricted = sessionStorage.getItem('isAccessRestricted') === 'true';

  return (
    <div>
      {!isAccessRestricted && <MaintenanceBanner />}
      { history.location.pathname.includes("recommendations") || history.location.pathname.includes("approvals") || history.location.pathname.includes("serverReview") || history.location.pathname.includes("client-sso-integration") ?
        <Fragment>
          <LoyoutWrapperContent>
            <LayoutContentWrapper style={{ width: '100%', minHeight: "calc(100vh - 70px)", overflow:'visible', padding: "0", position:'relative', top:'0px', left :'0px', right: '0px' }}>
              {children}
            </LayoutContentWrapper>
          </LoyoutWrapperContent>
        </Fragment> :
        <Fragment>
          <Navbar
            screenName={
              isAccessRestricted
                ? ""
                : history.location.pathname === "/"
                ? "Dashboard"
                : history.location.pathname.includes("/servers")
                ? "Servers"
                : history.location.pathname.includes("/fui")
                ? "Fulfillment"
                : history.location.pathname.includes("/ssh")
                ? "SSH Management"
                : history.location.pathname.includes("/admin")
                ? "Admin"
                : history.location.pathname.includes("/metrics")
                ? "Metrics"
                : history.location.pathname.includes("/genwizard")
                ? "Genwizard"
                : "FAQ"
            }
          />
          <LoyoutWrapperContent>
            {!isAccessRestricted && (
              <LayoutResponsiveSidebar>
                <ResponsiveSidebar currentRoute={history.location.pathname} />
              </LayoutResponsiveSidebar>
            )}
            <LayoutContentWrapper style={{
              height: isAccessRestricted ? "calc(100vh - 70px)" : "calc(100vdh - 100px)",
              overflow: isAccessRestricted ? 'hidden' : 'visible',
              paddingTop: isAccessRestricted ? "0" : "0 1em",
              padding: isAccessRestricted ? "0" : undefined,
              position: isAccessRestricted ? 'fixed' : 'absolute',
              top: isAccessRestricted ? '70px' : '10px',
              left: isAccessRestricted ? '0' : '90px',
              right: '0px',
              width: isAccessRestricted ? '100vw' : undefined,
              maxWidth: isAccessRestricted ? '100vw' : undefined
            }}>
              {children}
            </LayoutContentWrapper>
          </LoyoutWrapperContent>
          {/* <Footer /> */}
        </Fragment>
      }
    </div>
  );
};

const mapStateToProps = (state) => ({
  username: state.auth.userDetails.email
    ? state.auth.userDetails.email
        .replace(/@[^@]+$/, "")
        .replace(".", " ")
        .split(" ")
        .map(function(item) {
          return item[0];
        })
        .join("")
        .toUpperCase()
    : "",
  email: state.auth.userDetails.email,
  idToken: state.auth.idToken,
  isLoading: state.sidebarReducer.isLoading,
  sidebar_arrays: state.sidebarReducer.sidebar_arrays,
  sidebar_numbers: state.sidebarReducer.sidebar_numbers,
  isCheckboxServiceEndDateSelected:
    state.servers.isCheckboxServiceEndDateSelected,
  activeAccount: state.auth.activeAccount,
});

export default connect(mapStateToProps, {
  clearLocalComponentData,
  fetchServersInstances,
  isCheckboxServiceEndDateSelectedAction,
  fetchInstanceData,
})(CommonLayout);
